module.exports = __webpack_public_path__ + "static/img/3.5d7550b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/zh/3.png
// module id = SaLY
// module chunks = 0